// Normalize strings for comparison
export const normalizeText = (str?: string) =>
  str ? str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim() : "";

